import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/Transporter/Vehicle/add'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { v3_edit_transporter_vehicle } from '../../../actions/v3/trasnporterManagement'
const Add = (props) => {

    const location = useLocation();
    const { data, page } = location.state || {};
    const onSubmit = (model) => {
        model.previousName = JSON.parse(atob(data))['NAME']
        v3_edit_transporter_vehicle(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listTransporterVehicle.url, {
                    page: page // Replace 'yourData' with the data you want to pass
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }

    const onCancel = () => {
        props.history.push(constant.Authedcomponent.listTransporterVehicle.url, {
            page: page // Replace 'yourData' with the data you want to pass
        });
    }
    return (
        <React.Fragment>
            <Layout
                title={'Edit Vehicle'}>
                <Form
                    title={'Edit Vehicle'}
                    onSubmit={onSubmit}
                    data={JSON.parse(atob(data))}
                    buttonName={'Save Vehicle'}
                    onCancel={onCancel}


                />
            </Layout>

        </React.Fragment>
    )
}

export default Add